import { Text } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import dayjs from "dayjs";
import { memo, useCallback, useMemo } from "react";

import { cn } from "@/utils/cn";

import { ExpeditionsQueueStatusModalProps } from ".";
import { ExpeditionQueueListItemBase } from "./ExpeditionQueueListItemBase";
import { ExpeditionQueueStatusBase } from "./ExpeditionQueueStatusBase";
import { useVehiclesStatus } from "./useVehiclesStatus";

type VehiclesDropoutData = {
  company: { id: string; name: string };
  closedAt: string;
  device: string;
  ip: string;
  truck: {
    id: number;
    licensePlate: string;
    renavam: string;
  };
  driver: {
    id: number;
    name: string;
  };
  date: string;
};

type ExpeditionsQueueStatusDropoutModalProps = ExpeditionsQueueStatusModalProps & {};
export function ExpeditionsQueueStatusDropoutModal(_props: ContextModalProps<ExpeditionsQueueStatusDropoutModalProps>) {
  const { data, search, activeArray, state } = useVehiclesStatus<VehiclesDropoutData>({
    type: "dropout"
  });

  const renderItem = useCallback((vehicle: VehiclesDropoutData, i: number) => <DropoutItem droppoutData={vehicle} key={i} />, []);

  const list = useMemo(
    () => ({
      data: data[activeArray],
      virtualized: false as const,
      render: renderItem
    }),
    [data, activeArray, renderItem]
  );

  const slots = useMemo(
    () => ({
      search: {
        props: {
          searchValue: search.value,
          onSearchChange: search.onChange
        },
        disable: true
      }
    }),
    [search.value, search.onChange]
  );

  return <ExpeditionQueueStatusBase list={list} loading={state.isLoading} slots={slots} />;
}
interface DropoutItemProps {
  droppoutData: VehiclesDropoutData;
}
const DropoutItem = memo(({ droppoutData }: DropoutItemProps) => {
  const formattedClosedAt = dayjs(droppoutData.closedAt).format("DD/MM/YYYY [às] HH:mm");

  const Item = ({ label, value }: { label: string; value: string }) => (
    <div>
      <Text fw="bold">{label}:</Text>
      <Text lh="normal">{value}</Text>
    </div>
  );

  return (
    <ExpeditionQueueListItemBase
      driverName={droppoutData?.driver?.name}
      slots={{
        Wrapper: { className: cn("flex flex-col items-start") },
        DriverWrapper: { className: cn("w-full") },
        Plate: { plate: droppoutData.truck.licensePlate },
        ExpeditionDate: { date: droppoutData.closedAt }
      }}
      components={{
        Bottom: (
          <div className="grid grid-cols-1 gap-1.5 lg:grid-cols-[1fr_auto]">
            <Item label="Dispositivo" value={droppoutData.device} />
            <Item label="Previsão Cancelada" value={formattedClosedAt} />
            <Item label="IP" value={droppoutData.ip} />
          </div>
        )
      }}
    />
  );
});
DropoutItem.displayName = "DropoutItem";
